import React from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { DropdownMenuType } from 'ui-components/components/dropdown-menu/dropdown-menu-type';
import { DropdownMenuPosition } from 'ui-components/components/INTERNAL/dropdown/dropdown-menu-position';

import { CSWFieldId, getOrderDetailsFieldId } from '../../../../../constants/field-ids';
import { ComponentStates } from '../../../../../enums/component-states';
import PresetContainer from '../../../../../fulfillment-planner/presets/container';
import { useFulfillmentRestrictionsByFPId } from '../../../../../hooks/entities/selectors/fulfillment-plans';
import { useIsFedexHALByFulfillmentPlanId } from '../../../../../hooks/orders/use-fedex-hal-check';
import messages from '../../../fulfillment-plan/sections/configure-shipment/messages';

import style from './presets.module.less';
import buttonTextStyle from 'ui-components/components/button/button-text.module.less';

const menuId = getOrderDetailsFieldId(CSWFieldId.Presets);

const Presets = ({ fulfillmentPlanId }) => {
  const isFedexHalShipment = useIsFedexHALByFulfillmentPlanId(fulfillmentPlanId);
  const uiRestrictions = useFulfillmentRestrictionsByFPId(fulfillmentPlanId);

  const hidePresets = isFedexHalShipment || uiRestrictions?.applyPresets?.componentState === ComponentStates.Hidden;

  return (
    !hidePresets && (
      <PresetContainer
        chevronClassName={style.chevron}
        dropdownMenuType={DropdownMenuType.Menu}
        dropdownTogglerClassName={buttonTextStyle['button-text']}
        dropdownTogglerMessage={<FormattedMessage {...messages.preset} />}
        fulfillmentPlanId={fulfillmentPlanId}
        id={menuId}
        menuPosition={DropdownMenuPosition.BottomRight}
      />
    )
  );
};

export default Presets;

Presets.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};
